export { fromRdf, toRdf } from "rdf-literal";
import { DataFactory } from "rdf-data-factory";
export { DataFactory };
import { BindingsFactory as ComunicaBindingsFactory } from "@comunica/bindings-factory";
export const quadsToGraph = (quads) => {
    const graph = new Map();
    for (const quad of quads) {
        const s = quad.subject.value;
        const p = quad.predicate.value;
        const predicateMap = graph.get(s) || graph.set(s, new Map()).get(s);
        const termArray = predicateMap.get(p) || predicateMap.set(p, []).get(p);
        termArray.push(quad.object);
    }
    return graph;
};
export class TermFactory {
    constructor(dataFactory = new DataFactory()) {
        Object.defineProperty(this, "dataFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dataFactory = dataFactory;
    }
    fromJson(jsonTerm) {
        if (jsonTerm.type === "uri") {
            return this.dataFactory.namedNode(jsonTerm.value);
        }
        if (jsonTerm.type === "bnode") {
            return this.dataFactory.blankNode(jsonTerm.value);
        }
        if ("xml:lang" in jsonTerm) {
            return this.dataFactory.literal(jsonTerm.value, jsonTerm["xml:lang"]);
        }
        if ("datatype" in jsonTerm) {
            return this.dataFactory.literal(jsonTerm.value, this.dataFactory.namedNode(jsonTerm.datatype));
        }
        return this.dataFactory.literal(jsonTerm.value);
    }
}
export class BindingsFactory extends ComunicaBindingsFactory {
    constructor(dataFactory = new DataFactory(), termFactory = new TermFactory()) {
        super(dataFactory);
        Object.defineProperty(this, "localDataFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.localDataFactory = dataFactory;
        this.termFactory = termFactory;
    }
    fromJson(jsonBindings) {
        const bindingsEntries = Object.entries(jsonBindings).map(([varName, jsonTerm]) => {
            return [
                this.localDataFactory.variable(varName),
                this.termFactory.fromJson(jsonTerm),
            ];
        });
        return this.bindings(bindingsEntries);
    }
}
export class QuadFactory {
    constructor(dataFactory = new DataFactory(), termFactory = new TermFactory()) {
        Object.defineProperty(this, "dataFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dataFactory = dataFactory;
        this.termFactory = termFactory;
    }
    fromJson(jsonRdf) {
        const [s, p, o] = jsonRdf;
        return this.dataFactory.quad(this.dataFactory.namedNode(s), this.dataFactory.namedNode(p), this.termFactory.fromJson(o));
    }
}
